import React, { useEffect, useState } from 'react';
import { useNavigate, generatePath, Link, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const RateUpdationTool = () => {

  const apireq05042024 = process.env.REACT_APP_SERVER_API_URL+"/";
  
  const navigate = useNavigate();
  const [UserMasterDataGlobal, setUserMasterDataGlobal] = useState([]);
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());

  const usernameglobal = JSON.parse(localStorage.getItem('username'));
  const localstorage_id = JSON.parse(localStorage.getItem('localstorage_id'));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apireq05042024+`UserMaster/getdatabyusername?username=${usernameglobal}&localstorage_id=${localstorage_id}`);
        if(response.data == "logout") {
          navigatetologin();
        }
        if(response.data.UserMasterDataGlobal?.[0]?.accessto == "COLLECTION" && response.data.UserMasterDataGlobal?.[0]?.CompanyId != "5") {
          navigate('/DailyDeliverySheet');
        }
        if(response.data.UserMasterDataGlobal?.[0]?.accessto == "COLLECTION" && response.data.UserMasterDataGlobal?.[0]?.CompanyId == "5") {
          navigate('/DailyDeliverySheet_jadhav');
        }
        setUserMasterDataGlobal(response.data.UserMasterDataGlobal);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Initial fetch if usernameglobal is available
    if (usernameglobal) {
      fetchData();
    }

    // Set up interval to fetch data every 5 minutes
    const intervalId = setInterval(fetchData, 5 * 60 * 1000); // 5 minutes in milliseconds

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [usernameglobal]); // Dependency array includes usernameglobal

  useEffect(() => {
    if (usernameglobal === null) {
      navigate('/LoginPage');
    } else {
      // Reset last activity time whenever there's user interaction
      const handleUserActivity = () => {
        setLastActivityTime(Date.now());
      };

      window.addEventListener('mousemove', handleUserActivity);
      window.addEventListener('keydown', handleUserActivity);
      window.addEventListener('touchstart', handleUserActivity); // For touch devices

      return () => {
        window.removeEventListener('mousemove', handleUserActivity);
        window.removeEventListener('keydown', handleUserActivity);
        window.removeEventListener('touchstart', handleUserActivity);
      };
    }
  }, [usernameglobal, navigate]);

  useEffect(() => {
    const sessionTimeout = setTimeout(() => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - lastActivityTime;

      if (elapsedTime > 15 * 60 * 1000) { // Log out after 15 minutes of inactivity
        console.log('Logging out due to inactivity...');
        navigatetologin();
      } else {
        // If there's less than 15 minutes left, reset the timeout to avoid unnecessary checks
        sessionTimeout.refresh();
      }
    }, 15 * 60 * 1000); // Check for inactivity every 15 minutes (converted to milliseconds)

    return () => clearTimeout(sessionTimeout);
  }, [lastActivityTime, navigatetologin]);

  // console.log(UserMasterDataGlobal[0].usertype);
  async function navigatetologin() {
    const response = await axios.get(apireq05042024+`UserMaster/logout?username=${usernameglobal}`);
    localStorage.removeItem('username');
    localStorage.removeItem('localstorage_id');
    navigate('/loginpage');
  } 

  const MySwal = withReactContent(Swal);
  const [errors, seterrors] = useState({});
  const [defaultcenter, setdefaultcenter] = useState();
  const [CenterMasterData, setCenterMasterData] = useState([]);
  const [RouteMasterData, setRouteMasterData] = useState([]);
  const [defaultroutename, setdefaultroutename] = useState();

  const [formData, setFormData] = useState({
    centerid: '',
    routename: '',
    cowrate: '',
    buffrate: '',
    fromdate: '',
    todate: '',
    service_charges: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    const updatedFormData = {
      ...formData,
      [name]: value,
    };
    
    if(name == "centerid"){
      setdefaultcenter(value);
    }
    
    if(name == "routename"){
      setdefaultroutename(value);
    }

    setFormData(updatedFormData);
  }

  const handleApply = async (event) => {
    event.preventDefault();
  // const handleApply = () => {
    const data = {
      centerid: defaultcenter,
      routename: defaultroutename,
      fromdate: formData.fromdate,
      todate: formData.todate,
      cowrate: formData.cowrate,
      buffrate: formData.buffrate,
      service_charges: formData.service_charges,
      CompanyId: UserMasterDataGlobal?.[0]?.CompanyId,
      userid: UserMasterDataGlobal?.[0]?.userid,
      ApplyRateInCustomerMaster: ApplyRateInCustomerMaster
    }
    
    if ((data.cowrate || data.buffrate) && data.service_charges) {
      alert('Please insert either rate or service charge');
      return;
    }

    if (!(data.cowrate) && !(data.buffrate) && !(data.service_charges)) {
      alert('Please insert either rate or service charge');
      return;
    }

    const response = await axios.post(apireq05042024 + "OtherController/updaterates", data);
    if (response.status === 200) {
      if(response.data.message == "Transaction successfull") {
        MySwal.fire({
          html: <b>Transaction successfull</b>,
          icon: "success",
        });
      }
      else if(response.data.message == "Transaction failed") {
        MySwal.fire({
          html: <b>Transaction failed</b>,
          icon: "success",
        });
      }
    }

  };  

  //2) using axios
  useEffect(() => {
  // Fetch data from the specified URL
    if (UserMasterDataGlobal.length > 0) {
      axios.get(apireq05042024+`CenterMaster?CompanyId=${UserMasterDataGlobal[0]?.CompanyId}`)

      .then((response) => {
        // Access the response data directly using response.data
        if(!defaultcenter){
          setCenterMasterData(response.data.CenterMasterData);
          setdefaultcenter(response.data.CenterMasterData[0].centerid);
          if(UserMasterDataGlobal?.[0]?.usertype !== "ADMIN" && UserMasterDataGlobal?.[0]?.usertype !== "DAIRY OWNER") {
            setdefaultcenter(UserMasterDataGlobal?.[0]?.centerid);
            setFormData({
              ...formData,
              centerid: UserMasterDataGlobal?.[0]?.centerid,
            })
          }
        }
      })
      .catch((error) => console.error('Error fetching data:', error));
    }
  }, [UserMasterDataGlobal]);


  //2) using axios
  useEffect(() => {
    if (UserMasterDataGlobal.length > 0 && defaultcenter) {
      setRouteMasterData([]);
      const axiostoapi = apireq05042024+`RouteMaster/GetRouteByCenterIdAndCompanyId/${UserMasterDataGlobal[0]?.CompanyId}/${defaultcenter}`;
      axios.get(axiostoapi)
        .then((response) => {
          setRouteMasterData(response.data.RouteMasterData);
          setdefaultroutename(response.data.RouteMasterData[0].routename);
        })
        .catch((error) => console.error('Error fetching route data:', error));
    }
  //we put defaultcenter below because when its value changes everytime this routemaster useeffect code will get executed
  }, [UserMasterDataGlobal, defaultcenter]);

  const getCenterNameById = (centerid) => {
    const center = CenterMasterData.find(center => center.centerid === centerid);
    return center ? center.centername : '';
  };

  const [ApplyRateInCustomerMaster, setApplyRateInCustomerMaster] = useState(false);

  const handleApplyRateInCustomerMasterCheckBox = () => {
    setApplyRateInCustomerMaster(!ApplyRateInCustomerMaster);
  };

  return (
    <>
    <h1 style={{ color: 'white', backgroundColor: '#4229cb', padding: '9px', cursor: 'default', fontSize: 20 }} className="text-center"> Rate Updation Tool</h1>
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid" style={{color: 'black', color: 'rgb(230 238 247)', backgroundColor: 'rgb(0, 152, 121)', marginTop:'-5px', borderBottom: 'none', position: 'absolute'}}>

        <a className="navbar-brand" style={{color: 'rgb(230 238 247)'}} href="/" >Home</a>
        <ul className="navbar-nav">
            <li className="nav-item">
                <span className="nav-link" style={{cursor: 'default'}}>{`Welcome ${UserMasterDataGlobal?.[0]?.username}`}</span>
            </li>
        </ul>
        <a className="navbar-brand" onClick={navigatetologin} style={{ cursor: 'pointer', color: 'rgb(230 238 247)' }}>Log out</a>
        </div>
    </nav>
    <div className="container mt-5">
      <div className="card shadow rounded p-4" >
        <h4 className="mb-2">Rate Updation Tool</h4>
        <div className="row g-3">
          <div className="col-md-2" style={{display: 'none'}}>
            <label className="form-label">Center ID</label>
            <input type="text" className="form-control" name="centerid" value={formData.centerid} onChange={handleInputChange} />
          </div>

          <div className="col-md-6">
            <label className="form-label">Center Name</label>
            
            <select
                  className="form-select"
                  id="id-centerid"
                  name="centerid" // <-- should match `formData.uom1` property
                  value={defaultcenter}
                  onChange={handleInputChange}
                  disabled={
                    UserMasterDataGlobal?.[0]?.usertype !== "ADMIN" &&
                    UserMasterDataGlobal?.[0]?.usertype !== "DAIRY OWNER"
                  }
                >
                {/* uom option from selected record when available */}
                {defaultcenter && (
                  <option key={defaultcenter} value={defaultcenter}>
                    {getCenterNameById(defaultcenter)}
                  </option>
                )}

                {/* dynamically fetched options */}
                {CenterMasterData.map((cp) => (
                  defaultcenter !== cp.centerid ?
                    <option key={cp.centerid} value={cp.centerid} >
                      {cp.centername}
                    </option>
                  : null
                ))}
                </select>

          </div>

          <div className="col-md-6">
            <label className="form-label">Line Name</label>
            
            <select
                className="form-select"
                id="id-routename" 
                name="routename"
                value={defaultroutename}
                onChange={handleInputChange}
              >

              {defaultroutename && (
                <option value={defaultroutename}>
                  {defaultroutename}
                </option>
              )}

              {RouteMasterData.map((r) => (
                 defaultroutename !== r.routename ?
                 <option key={r.routecode} value={r.routename}>
                   {r.routename}
                 </option>
                  : null
              ))}
              </select>

          </div>

          <div className="col-md-6">
            <label className="form-label">From Date</label>
            <input type="date" className="form-control" name="fromdate" value={formData.fromdate} onChange={handleInputChange} />
          </div>

          <div className="col-md-6 mb-2">
            <label className="form-label">To Date</label>
            <input type="date" className="form-control" name="todate" value={formData.todate} onChange={handleInputChange} />
          </div>
          
          <hr />
          
          <div className='row'>
            <div className="col-md-6">
              <label className="form-label">Cow Rate</label>
              <input type="number" className="form-control" name="cowrate" value={formData.cowrate} onChange={handleInputChange} />
            </div>

            <div className="col-md-6">
              <label className="form-label">Buff Rate</label>
              <input type="number" className="form-control" name="buffrate" value={formData.buffrate} onChange={handleInputChange} />
            </div>
          </div>
            
          <div className="col-md-6">
            <input className="form-check-input" type="checkbox" checked={ApplyRateInCustomerMaster} onChange={handleApplyRateInCustomerMasterCheckBox} name="ApplyRateInCustomerMaster" style={{marginTop: '20px'}} />
            &nbsp;<label className="form-check-label" htmlFor="flexCheckDefault" style={{marginTop: '15px'}}>
            Apply Rates in Customer Master
            </label>
          </div>
          
          <hr />

          <div className='row'>
            <div className="col-md-6">
              <label className="form-label">Service Charges</label>
              <input type="number" className="form-control" name="service_charges" value={formData.service_charges} onChange={handleInputChange} />
            </div>
          </div>

          <div className="col-12 text-center mt-4">
            <button className="btn btn-primary w-50" onClick={handleApply}>Apply</button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default RateUpdationTool;
